import React from "react";
import Editor from "componentes/editor";
import {
  Container,
  Col,
  Row,
  ButtonGroup,
  Button,
  Form,
  Label,
  Input,
  FormGroup
} from "reactstrap";
import {
  MdKeyboardReturn,
  MdSave
} from "react-icons/lib/md";

const ProcessoParecerForm = ({ salvar, history, parecer, quandoMudar, situacoes, somenteLeitura = false }) => {
  const { situacao: { id: situacaoId, descricao } = {} } = parecer;

  return <Form onSubmit={e => salvar(e, history)}>
    <Container>
        <Row>
          <Col sm={12}>
            <FormGroup>
              <Label className="lbl-required">Relatório</Label>
              <Editor chave="parecer" conteudo={parecer.texto} somenteLeitura={somenteLeitura} placeholder="Incluir relatório..."/>
            </FormGroup>
          </Col>
          <Col sm={12}>
            <FormGroup>
              <Label>Resultado final</Label>
              {somenteLeitura && <Input plaintext>{descricao}</Input>}
              {
                !somenteLeitura &&
                <Input type="select" name="parecer_situacaoId" value={situacaoId} onChange={quandoMudar}>
                  <option key="" value="" />
                  {
                    situacoes.map(({ id, descricao }) => <option key={id} value={id}>{descricao} </option>)
                  }
                </Input>
              }
            </FormGroup>
          </Col>
        </Row>
        {
          !somenteLeitura &&
          <Row>
            <Col sm={12}>
              <ButtonGroup size="sm" className="float-right">
                <Button type="reset" color="secondary" onClick={history.goBack}><MdKeyboardReturn />Voltar</Button>
                <Button type="submit" color="warning"><MdSave />{' '}Salvar</Button>
              </ButtonGroup>
            </Col>
          </Row>
        }
    </Container >
  </Form>;
};

export default ProcessoParecerForm;



// WEBPACK FOOTER //
// ./src/componentes/ProcessoParecerForm.js